import { render } from "./index-tabs.vue?vue&type=template&id=8ea220ac&lang=pug"
import script from "./index-tabs.vue?vue&type=script&lang=js"
export * from "./index-tabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__